var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddList01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #000;\n        stroke-linejoin: round;\n        stroke-width: 0.75px;\n      }\n\n      .cls-1 {\n        stroke-linecap: round;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "add list") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "7.71 4.46 4.8 4.46 4.8 8.98 9.2 8.98 9.2 6.33"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "6.08 5.67 7.16 6.79 9.35 4.6"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 5.02,
    y: 12.57,
    width: 2.52,
    height: 2.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 5.02,
    y: 17.35,
    width: 2.67,
    height: 2.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 12.06,
    y1: 12.75,
    x2: 18.25,
    y2: 12.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 12.06,
    y1: 14.69,
    x2: 15.23,
    y2: 14.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 12.06,
    y1: 17.91,
    x2: 18.1,
    y2: 17.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 12.06,
    y1: 19.62,
    x2: 15.23,
    y2: 19.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 13.52,
    y1: 6.72,
    x2: 16.65,
    y2: 6.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 13.52,
    y1: 8.84,
    x2: 15.74,
    y2: 8.84
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.93,
    y: 1,
    width: 21.19,
    height: 22.48,
    rx: 2.43
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddList01);
export default __webpack_public_path__ + "static/media/add_list_01.456fe98d716a0c769f8d9b15ba233aa3.svg";
export { ForwardRef as ReactComponent };